// extracted by css-extract-rspack-plugin
export default {"cls1":"LanguageDropdown-cls1_hGj","cls2":"LanguageDropdown-cls2_XwU LanguageDropdown-cls1_hGj"};